import { Fragment, useState } from "react";
import {useNavigate } from "react-router-dom";
import useUpdateLicenses from "../../lib/useUpdateLicenses";
import { ReactComponent as UploadIcon } from "../../../Asset/upload-cloud-02.svg";
import { ReactComponent as AddIcon } from "../../../Asset/add-circle.svg";
import { IoCheckmarkDoneCircleOutline } from "react-icons/io5";
import { RiDeleteBin5Line } from "react-icons/ri";
import { CiFileOn } from "react-icons/ci";
import { ToastContainer } from "react-toastify";
import Spinner from "../../../Utils/spinner/loading";
import { ReactComponent as BlackVatugIcon } from "../../../Asset/black.svg";
import "./updatelicenses.css";

const UpdateLicenses = () => {
  const navigate = useNavigate();
  const { handleSubmit, loading, error, success } = useUpdateLicenses();
  const [formData, setFormData] = useState([]);

  // Define the allowed document types
  const allowedDocuments = [
    { value: "nimasa", label: "Nimasa" },
    { value: "dpr", label: "DPR" },
    { value: "npa", label: "NPA" },
  ];

  // Function to dynamically filter available options based on selected items in other fields
  const getAvailableOptions = (index) => {
    const selectedNames = formData.map((item) => item.name);
    const filteredOptions = allowedDocuments.filter(
      (doc) =>
        !selectedNames.includes(doc.value) ||
        formData[index]?.name === doc.value
    );
    return filteredOptions;
  };

  // Handle file selection and updates for each document
  const handleFileChange = (e, index) => {
    const file = e.target.files[0];
    const newFormData = [...formData];
    newFormData[index] = {
      name: newFormData[index] ? newFormData[index].name : "",
      file: file,
    };
    setFormData(newFormData);
  };

  // Handle document name selection
  const handleNameChange = (e, index) => {
    const newName = e.target.value;
    const newFormData = [...formData];
    newFormData[index] = {
      name: newName,
      file: newFormData[index] ? newFormData[index].file : null,
    };
    setFormData(newFormData);
  };

  // Add a new document input field
  const addDocumentField = () => {
    setFormData([...formData, { name: "", file: null }]);
  };

  // Remove a document input field
  const removeDocument = (index) => {
    const newFormData = [...formData];
    newFormData.splice(index, 1);
    setFormData(newFormData);
  };

  // Handle form submission
  const handleFinish = (e) => {
    e.preventDefault();
    handleSubmit(e, formData);
  };

  // Format the file size for display
  const formatFileSize = (size) => {
    if (size >= 1000000) {
      return (size / 1000000).toFixed(2) + " MB";
    } else if (size >= 1000) {
      return (size / 1000).toFixed(2) + " KB";
    } else {
      return size + " bytes";
    }
  };

  // Capitalize the first letter of each word
  const capitalizeInitial = (str) => {
    return str
      .split(" ")
      .map((word) => word.charAt(0).toUpperCase() + word.slice(1))
      .join(" ");
  };

  return (
    <Fragment>
      <ToastContainer />
      <div className="update-licenses">
        <div className="wrap">
        <div className="header">
          <button onClick={() => navigate("/typeofupdate")}>Back</button>
          <BlackVatugIcon/>
          <button
            className="finished"
            onClick={handleFinish}
            disabled={loading}
          >
            {loading ? <Spinner /> : "Finish"}
          </button>
        </div>
        <form>
          <h2>Update Licenses</h2>

          {formData.map((item, index) => (
            <div key={index} className="card">
              <select
                value={item.name}
                onChange={(e) => handleNameChange(e, index)}
              >
                <option value="">Select name of document</option>
                {getAvailableOptions(index).map((doc) => (
                  <option key={doc.value} value={doc.value}>
                    {doc.label}
                  </option>
                ))}
              </select>

              {!item.file && (
                <label>
                  Document
                  <span>
                    <input
                      type="file"
                      hidden
                      onChange={(e) => handleFileChange(e, index)}
                    />
                    {!item.file && (
                      <>
                        <UploadIcon />
                        <p>
                          Drop pdf here, <span>or browse</span>
                        </p>
                        <h5>Supports: PDF</h5>
                      </>
                    )}
                  </span>
                </label>
              )}

              {item.file && (
                <div className="uploaded">
                  <div className="wrap">
                    <CiFileOn className="file" />
                    <div className="in">
                      <span>
                        <h3>{capitalizeInitial(item.name)}</h3>
                        {/* <p>{item.file.name}</p> */}
                      </span>
                      <p>{formatFileSize(item.file.size)} - 100% Uploaded</p>
                    </div>
                  </div>
                  <div className="last">
                    <IoCheckmarkDoneCircleOutline className="mark" />
                    <RiDeleteBin5Line
                      onClick={() => removeDocument(index)}
                      className="delete"
                    />
                  </div>
                </div>
              )}
            </div>
          ))}

          <span type="button" onClick={addDocumentField}> 
            <AddIcon />
            {formData.length <= 0 ? "Add Document" : "Add More Document"}
          </span>

          {formData.length > 0 && (
            <button onClick={handleFinish} disabled={loading}>
              {loading ? <Spinner /> : "Finish"}
            </button>
          )}

          {error && (
            <p
              style={{ margin: "auto", color: "red", fontFamily: "Montserrat" }}
            >
              {error}
            </p>
          )}
          {success && (
            <p
              style={{
                margin: "auto",
                color: "green",
                fontFamily: "Montserrat",
              }}
            >
              {success}
            </p>
          )}
        </form>
        </div>
      </div>
    </Fragment>
  );
};

export default UpdateLicenses;
